<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card>
        <tt-button-goto ttText="deliverycustomers_new" ttGoto="deliverycustomer" [ttGotoParms]="{ deliverycustomer_keyno: '0', cust_no: setting.cust_no }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListCustomers"></tt-list>
</tt-page>
